<template>
  <button
    class="btn icon small-icon small obituary-threaded-comments__button"
    @click.prevent="openModal"
  >
    <svg class="icon"><use href="#message" /></svg>
    <span v-text="texts.comment" />
  </button>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'ThreadedCommentsButton',

  props: {
    parent: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      texts: lavendlaObituary.common,
    };
  },

  methods: {
    ...mapMutations('threadedComments', ['setParent']),
    ...mapActions('threadedComments', ['toggleModal']),

    openModal() {
      this.setParent(this.parent);
      this.toggleModal('create');
    },
  },
};
</script>
